import { Company_User_Role, Company_User_Status } from "@generated/graphql";
import { COMPANY_USER_ROLE_TITLE, COMPANY_USER_STATUS_TITLE } from "constants/company";

const TEAM_ROLE_OPTIONS = [
  {
    value: Company_User_Role.Hr,
    label: COMPANY_USER_ROLE_TITLE[Company_User_Role.Hr],
    color: "#059669",
    backgroundColor: "#ECFDF5",
    hint: "Полный доступ к платформе: карты компетенций, тестирования, кандидаты.",
  },
  {
    value: Company_User_Role.Methodologist,
    label: COMPANY_USER_ROLE_TITLE[Company_User_Role.Methodologist],
    color: "#2952E3",
    backgroundColor: "#EEF2FF",
    hint: "Аналогично HR на текущей итерации. В будущем - акцент на подготовке КК.",
  },
  {
    value: Company_User_Role.Administrator,
    label: COMPANY_USER_ROLE_TITLE[Company_User_Role.Administrator],
    color: "#0EA5E9",
    backgroundColor: "#EEF2FF",
    hint: "Техническая роль. Доступ к API-ключам и настройкам (в разработке).",
  },
  {
    value: Company_User_Role.Reviewer,
    label: COMPANY_USER_ROLE_TITLE[Company_User_Role.Reviewer],
    color: "#D97706",
    backgroundColor: "#FFFBEB",
    hint: "Урезанный доступ: только просмотр и ревью назначенных оценок (в разработке).",
  },
];

export const TEAM_STATUS_OPTIONS: Record<
  Company_User_Status,
  { label: string; color: string; backgroundColor: string }
> = {
  [Company_User_Status.Active]: {
    label: COMPANY_USER_STATUS_TITLE[Company_User_Status.Active],
    color: "#059669",
    backgroundColor: "#ECFDF5",
  },
  [Company_User_Status.Pending]: {
    label: COMPANY_USER_STATUS_TITLE[Company_User_Status.Pending],
    color: "#D97706",
    backgroundColor: "#FFFBEB",
  },
  [Company_User_Status.Deactivated]: {
    label: COMPANY_USER_STATUS_TITLE[Company_User_Status.Deactivated],
    color: "#94A3B8",
    backgroundColor: "#F7F9FF",
  },
};

export default TEAM_ROLE_OPTIONS;
